import {
  FETCH_ALL_OPERATORS,
  FETCH_ALL_OPERATORS_SUCCESS,
  FETCH_ALL_OPERATORS_FAILED,
  EDIT_OPERATOR,
  EDIT_OPERATOR_SUCCESS,
  EDIT_OPERATOR_FAILED,
  DELETE_OPERATOR,
  DELETE_OPERATOR_SUCCESS,
  DELETE_OPERATOR_FAILED,
} from "../store/types";
import {
  cloud_function_server_url,
} from '../../config';

const END_POINT = `${cloud_function_server_url}/user`;

export const fetchOperators = () => (dispatch) => (firebase) => {

  // const {
  //   operatorsRef
  // } = firebase;

  dispatch({
    type: FETCH_ALL_OPERATORS,
    payload: null
  });

  fetch(`${END_POINT}/fetch-operators`, {
    method: 'GET',
  })
    .then(async (res) => {
      const response = await res.json();
      console.log("fetchOperators", response)
      if(response?.success) {
        const arr = response.data?.map((item) => {
          item.id = item._id;
          return item;
        });
        dispatch({
          type: FETCH_ALL_OPERATORS_SUCCESS,
          payload: arr
        });
      } else {
        dispatch({
          type: FETCH_ALL_OPERATORS_FAILED,
          payload: "No users available."
        });
      }
    }).catch(error => {
      console.log("fetchOperators error", error)
      dispatch({
        type: FETCH_ALL_OPERATORS_FAILED,
        payload: "No users available."
      });
    });

  // operatorsRef.on("value", snapshot => {
  //   if (snapshot.val()) {
  //     const data = snapshot.val();
  //     const arr = Object.keys(data)
  //       .map(i => {
  //         data[i].id = i;
  //         return data[i];
  //       });
  //     dispatch({
  //       type: FETCH_ALL_OPERATORS_SUCCESS,
  //       payload: arr
  //     });
  //   } else {
  //     dispatch({
  //       type: FETCH_ALL_OPERATORS_FAILED,
  //       payload: "No users available."
  //     });
  //   }
  // });
};

export const addOperator = (operatordata) => (dispatch) => (firebase) => {
  const {
    operatorsRef
  } = firebase;

  dispatch({
    type: EDIT_OPERATOR,
    payload: operatordata
  });

  operatorsRef.push(operatordata).then(() => {
    dispatch({
      type: EDIT_OPERATOR_SUCCESS,
      payload: null
    });
  }).catch((error) => {
    dispatch({
      type: EDIT_OPERATOR_FAILED,
      payload: error
    });
  });

}

export const editOperator = (id, operator) => (dispatch) => (firebase) => {

  const {
    singleOperatorRef
  } = firebase;

  dispatch({
    type: EDIT_OPERATOR,
    payload: operator
  });
  let editedOperator = operator;
  delete editedOperator.id;
  singleOperatorRef(id).set(editedOperator).then(() => {
    dispatch({
      type: EDIT_OPERATOR_SUCCESS,
      payload: null
    });
  }).catch((error) => {
    dispatch({
      type: EDIT_OPERATOR_FAILED,
      payload: error
    });
  });
}

export const deleteOperator = (id) => (dispatch) => (firebase) => {

  const {
    singleOperatorRef
  } = firebase;

  dispatch({
    type: DELETE_OPERATOR,
    payload: id
  });

  singleOperatorRef(id).remove().then(() => {
    dispatch({
      type: DELETE_OPERATOR_SUCCESS,
      payload: null
    });
  }).catch((error) => {
    dispatch({
      type: DELETE_OPERATOR_FAILED,
      payload: error
    });
  });
}